import { useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { $journalApi } from "@/entities/journal/fetch/fetch-client";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";

export const useSendSignEntry = (sectionOneId: string, search?: string) => {
  const queryClient = useQueryClient();

  const { mutate: sendToSign } = $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-one/{sectionOneListId}/items/{itemNoVersionId}/sendToSignItem",
    {
      onSuccess: () => {
        notification.success({ message: NOTIFICATION_MESSAGES.ENTRY_SENT_TO_SIGNING }); // "Отправлено на подписание"

        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({ sectionOneId, search })
            .queryKey,
        });
        queryClient.invalidateQueries({
          queryKey:
            journalsQueries.getSectionOneSignersList(sectionOneId).queryKey,
        });
      },
      onError: () => {
        notification.error({ message: NOTIFICATION_MESSAGES.ENTRY_SEND_TO_SIGNING_ERROR }); // "Ошибка при отправке на подписание"
      },
    },
  );

  const handleSend = ({
    sectionOneListId,
    itemNoVersionId,
  }: {
    sectionOneListId: string;
    itemNoVersionId: string;
  }) => {
    sendToSign({
      params: {
        path: { sectionOneListId, itemNoVersionId },
      },
    });
  };

  return { handleSend };
};
